module.exports = __webpack_public_path__ + "public/SiteIcons/googleVerifiMenu.png?c9dfdee6";